import React from 'react'
import { FeedbackDialog } from './feedback-dialog'
import { FeedbackDialogProps } from './insight-feedback'

/**
 * InsightFeedbackDialog - A wrapper for insight-specific feedback
 *
 * This component pre-configures FeedbackDialog with feedbackType="insight"
 * and ensures proper unmounting when closed for cache synchronization.
 *
 * For play feedback, use FeedbackDialog directly with feedbackType="play"
 */
export function InsightFeedbackDialog(
  props: Omit<FeedbackDialogProps, 'feedbackType'> & { feedbackType?: 'insight' }
) {
  const { isOpen, ...restProps } = props

  // Render nothing if not open - this unmounts FeedbackDialog completely
  // ensuring useState initializers run fresh with correct cache values when reopening
  if (!isOpen) return null

  return <FeedbackDialog isOpen={isOpen} feedbackType="insight" {...restProps} />
}
